import api from "lib/api";

export const getEmailLoopList = async (params) =>
    await api.post("/v1/emailTemplate/getEmailLoopList", params);

export const saveEmailLoop = async (params) =>
    await api.post("/v1/emailTemplate/saveEmailLoop", params);

export const deleteEmailLoop = async (params) =>
    await api.post("/v1/emailTemplate/deleteEmailLoop", params);

export const getEmailLoopMemberList = async (params) =>
    await api.post("/v1/emailTemplate/getEmailLoopMemberList", params);

export const previewEmailLoopMember = async (params) =>
    await api.post("/v1/emailTemplate/previewEmailLoopMember", params);

export const getDepartmentOptions = async (params = {}) =>
    await api.post("/v1/dropdown/getStmDepartment", params);

export const getPositionOptions = async (params = {}) =>
    await api.post("/v1/position/getPosition", params);